/* unplugin-vue-components disabled */import script from "./DramaHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaHeader.vue?vue&type=script&setup=true&lang=js"

import "./DramaHeader.vue?vue&type=style&index=0&id=a6039008&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6039008"]])

export default __exports__